export default __webpack_public_path__ + "static/media/Backgroundbig.df64ccfa.png";